//@flow
import React from 'react';
import FloatLabelInput from '../../Form/components/FloatLabelInput.react';
import Select from '../../Form/components/Select.react';
import CreateAccountModalActions from '../../Actions/createAccountModal';
import _ from 'underscore';

type Props = { formData?:Object };
type State = { otherField:boolean };

export default class HowDidYouHear extends React.Component<Props, State> {
  state = { otherField: false };

  _showMethods():Object[] {
    const methods = _.shuffle(['Friends/Family','Blog','Podcast','Facebook','YouTube','Catalog/Mailer','Radio','Target']);
    const optionsArr = _.map(methods, value => {
      return { title: value, value };
    });

    return [{title: 'How did you hear about us?', value: ''}]
      .concat(optionsArr).concat([{title: 'Other', value: 'Other'}]);
  }

  showOtherField() {
    this.setState({
      otherField: true,
    });
    CreateAccountModalActions.expandCreateAccountModal();
  }

  hideOtherField() {
    this.setState({
      otherField: false,
    });
    CreateAccountModalActions.collapseCreateAccountModal();
  }

  toggleOtherField = (e:Object) => {
    if (e.target.value) {
      this.hideOtherField();
    }
    if (e.target.value === 'Other') {
      this.showOtherField();
    }
  }

  renderOtherField() {
    if (this.state.otherField) {
      return (
        <FloatLabelInput
          type="text"
          name="howDidYouHearInput"
          formData={this.props.formData}
          className="input-how-did-you-hear"
          showFloat={true}
          placeholder="Please specify"
          title="How did you hear about us?"
          validations="maxLength:60"
        />
      );
    }
  }

  render() {
    return (
      <div>
        <Select
          name="howDidYouHearSelect"
          formData={this.props.formData}
          className="how-did-you-hear"
          options={this._showMethods()}
          onChange={this.toggleOtherField}
        />
        {this.renderOtherField()}
      </div>
    );
  }
}
